import { render, staticRenderFns } from "./integralEden.vue?vue&type=template&id=63e72e91&scoped=true"
import script from "./integralEden.vue?vue&type=script&lang=js"
export * from "./integralEden.vue?vue&type=script&lang=js"
import style0 from "./integralEden.vue?vue&type=style&index=0&id=63e72e91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e72e91",
  null
  
)

export default component.exports